import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ComplaintsState } from './complaints.reducer';

export const selectComplaintsState =
	createFeatureSelector<ComplaintsState>('complaints');

export const selectComplaintsEntities = createSelector(
	selectComplaintsState,
	(state: ComplaintsState) => state.complaints
);

export const selectLastUpdate = createSelector(
	selectComplaintsState,
	(state: ComplaintsState) => state.lastUpdate
);

export const selectLoading = createSelector(
	selectComplaintsState,
	(state: ComplaintsState) => state.loading
);

export const selectError = createSelector(
	selectComplaintsState,
	(state: ComplaintsState) => state.error
);

export const selectComplaintsPerPeriod = createSelector(
	selectComplaintsState,
	(state: ComplaintsState) => state.complaintsPerPeriod
);

export const selectBusLines = createSelector(
	selectComplaintsState,
	(state: ComplaintsState) => state.busLines
);

export const selectSse = createSelector(
	selectComplaintsState,
	(state: ComplaintsState) => state.sse
);
